export class ApiError extends Error {
  readonly status: number;
  readonly code: string;
  readonly details: Readonly<Record<string, unknown>>;
  /** `x-request-id` of the failed response (support reference); `null` when absent. */
  readonly requestId: string | null;
  /** `Retry-After` seconds on a 429, else `null`. */
  readonly retryAfterSeconds: number | null;

  constructor(
    status: number,
    code: string,
    message: string,
    details: Readonly<Record<string, unknown>> = {},
    meta: { requestId?: string | null; retryAfterSeconds?: number | null } = {},
  ) {
    super(message);
    this.name = "ApiError";
    this.status = status;
    this.code = code;
    this.details = details;
    this.requestId = meta.requestId ?? null;
    this.retryAfterSeconds = meta.retryAfterSeconds ?? null;
  }
}

export function errorMeta(response: Response) {
  const retryAfter = Number(response.headers.get("retry-after"));
  return {
    requestId: response.headers.get("x-request-id"),
    retryAfterSeconds: Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter : null,
  };
}

export function isApiError(error: unknown): error is ApiError {
  return error instanceof ApiError;
}
